export const EUROPEAN_DATE_FORMAT = 'dd/MM/yyyy'
export const LONG_DATE_FORMAT = 'd MMM yyyy'
